// extracted by mini-css-extract-plugin
export default {"mainhome":"home_mainhome__1A2yV","hmpage":"home_hmpage__yPtSM","bubblediv":"home_bubblediv__VTCa7","bubble":"home_bubble__S5fwz"};